import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { AutomationService } from 'src/app/core/services/automation/automation.service';
import { Subject, takeUntil } from 'rxjs';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { UniversityService } from 'src/app/core/services/university/university.service';


@Component({
  selector: 'app-automation-sidebar',
  templateUrl: './automation-sidebar.component.html',
  styleUrls: ['./automation-sidebar.component.scss']
})
export class AutomationSidebarComponent {
  university_pagination = {
    skip: 0,
    limit: 50000
  }
  universityList : {
    universityName: string,
    universityId: string
  }[]= [];
 
 
  //       universityName: 'Griffith College, Ireland',
  //    
  
  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private router: Router, 
    private _automationService: AutomationService,
    private _loaderService: LoaderService,
    private _universityService: UniversityService,

  ) {}
  ngOnInit(): void {
    this.getUniversity()
  }
  getUniversity() {
    this._universityService.getAllUniversity(this.university_pagination, )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
          res.data.data.map((e)=>{
            this.universityList.push({
              universityName: e?.name,
              universityId: e?.id,
          });
        })
      }, (err) => {
        console.log("err",err);

      })
  }
  getUnivervistyData(university) {
    const url = `/${urlRoutes.mainLayout}/${urlRoutes.automation_log}`;
    this.router.navigate([`${url}/${university?.universityId}/${university?.universityName}`]).then(() => {
      this._automationService.currentlySelected.next(university)
     
    })

  }
}
